import Loadable from 'react-loadable';
import PageLoading from './skeleton/pageLoading'
export default (loader,loading = PageLoading)=>{
    return Loadable({
        loader,
        loading
    });
}